export function requirePositiveId(value: unknown, message: string): number {
  const id = Number(value);

  if (!Number.isFinite(id) || id <= 0) {
    throw new Error(message);
  }

  return id;
}
